import React from 'react';
import { Container, Box } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import PetLicenseAcknowledgement from './PaymentAcknowledgementPages/PetLicense';

const PetLicensePaymentAcknowledgement: React.FC = () => {
  const [searchParams] = useSearchParams();

  // Get data from URL parameters
  const applicationNumber = searchParams.get('applicationNumber') || null;
  const userName = searchParams.get('userName') || 'User';
  const totalAmountPayable = searchParams.get('totalAmountPayable') || '0.00';
  const totalAmountWithoutTax =
    searchParams.get('totalAmountWithoutTax') || '0.00';
  const totalTaxAmount = searchParams.get('totalTaxAmount') || '0.00';
  const townshipId = searchParams.get('townshipId');
  const department = searchParams.get('department');
  const permit = searchParams.get('permit');

  // Construct basePath from query params if available, otherwise use default
  const basePath =
    townshipId && department && permit
      ? `/${townshipId}/${department}/${permit}`
      : '/dashboard';

  return (
    <Container
      component="main"
      maxWidth="md"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        p: { xs: 1.5, sm: 3 },
        mt: 4
      }}
    >
      <Box sx={{ width: '100%', maxWidth: '800px' }}>
        <PetLicenseAcknowledgement
          applicationDetails={{
            userName: userName
          }}
          applicationNumber={applicationNumber}
          basePath={basePath}
          totalAmountPayable={totalAmountPayable}
          totalAmountWithoutTax={totalAmountWithoutTax}
          totalTaxAmount={totalTaxAmount}
        />
      </Box>
    </Container>
  );
};

export default PetLicensePaymentAcknowledgement;
